import styled from 'styled-components';

export const EditContentStyled = styled.div`
  min-height: 70vh;
`;
